import React from 'react';

const Terms = () => {
  return (
    <div className="privacy-legal">

    </div>
  );
};

export default Terms;